module.exports = __webpack_public_path__ + "static/media/30.04859d45.jpeg";